import { useHistory, useLocation } from "react-router-dom";
import qs from "query-string";

export default function useQueryParam(name) {
  const history = useHistory();
  const location = useLocation();
  let query = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const value = query[name] ?? null;

  const set = (item) => {
    let query = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    });
    query[name] = item;
    const stringified = qs.stringify(query);
    history.push(history.location.pathname + "?" + stringified);
  };

  const remove = () => {
    let query = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    });
    delete query[name];
    const stringified = qs.stringify(query);
    history.push(history.location.pathname + "?" + stringified);
  };

  return [value, set, remove];
}
